'use client';

import type { JourneyAlias, JourneyId } from '@hc-frontend/core-types';
import { createContext, useContext, useMemo } from 'react';

import type { JourneyContextProviderProps } from './use-journey.types';

const JourneyContext = createContext<{
  journeyAlias?: JourneyAlias;
  journeyId: JourneyId;
}>({ journeyAlias: undefined, journeyId: 0 });

export const useJourney = () => useContext(JourneyContext);

export function JourneyContextProvider({
  children,
  journeyAlias,
  journeyId,
}: JourneyContextProviderProps): JSX.Element {
  const value = useMemo(
    () => ({
      journeyAlias,
      journeyId,
    }),
    [journeyAlias, journeyId],
  );

  return (
    <JourneyContext.Provider value={value}>{children}</JourneyContext.Provider>
  );
}
